export const appCdnURL = "https://static.pilarhomes.com.br/d4aa515b91d64293d68caea5e03e970a62896c02"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"description","content":"Imóveis de luxo"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"apple-mobile-web-app-title","content":"PilarHomes"},{"name":"theme-color","media":"(prefers-color-scheme: light)","content":"white"},{"name":"theme-color","media":"(prefers-color-scheme: dark)","content":"#222222"},{"property":"og:site_name","content":"PilarHomes"}],"link":[{"rel":"icon","type":"image/svg+xml","sizes":"any","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"128x128","href":"/android-chrome-128x128.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/android-chrome-512x512.png"},{"rel":"icon","type":"image/x-icon","sizes":"16x16","href":"/favicon-16x16.ico"},{"rel":"icon","type":"image/x-icon","sizes":"32x32","href":"/favicon-32x32.ico"},{"rel":"icon","type":"image/x-icon","sizes":"48x48","href":"/favicon-48x48.ico"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon-180x180.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"167x167","href":"/apple-touch-icon-167x167.png"},{"rel":"preconnect","href":"https://static.pilarhomes.com.br/d4aa515b91d64293d68caea5e03e970a62896c02","crossorigin":""},{"rel":"preconnect","href":"https://imagens.pilarhomes.com.br","crossorigin":""}],"style":[],"script":[],"noscript":[],"viewport":"width=device-width, initial-scale=1, maximum-scale=1"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true